import React, { Component } from 'react';
import ReactDOM from 'react-dom'
import Lombax from './Lombax'
import classNames from 'classnames'
import Emboldinator from './Emboldinator'
import moment from 'moment'
import Modal from 'react-modal'

document.body.addEventListener('click', function(){
    setTimeout(function(){
        if(global.$$root$$.show_popover){
            global.$$root$$.show_popover = false
            globalUpdate()    
        }
    }, 10)
})

import { collectEntity } from '../quark/collect'

class EntityRenameDialog extends Component {
    constructor(){
        super()
        var line = quark.root()
        this.state = {
            text: get(line.ref).text
        }
    }
    componentDidMount(){
        setTimeout(e => 
            ReactDOM.findDOMNode(this.refs.namefield).focus()
        , 100)
    }
    closeModal(){
        global.$$root$$.is_renaming = false
        globalUpdate()
    }
    updateText(e){
        this.setState({
            text: e.target.value
        })
    }
    doRename(){
        var text = this.state.text.trim()
        quark.core.update(quark.root().ref, { text }); 
        this.closeModal()
    }

    doMerge(){
        var text = this.state.text.trim()
        var newid = quark.root().ref,
            curent = get(newid)

        var alterid = quark.find_name(text),
            alter = quark.get(alterid)
        enlist(alter).forEach(k => 
            quark.core.update(k.id, { parent: newid })
        )
        quark.core.del(alterid)

        quark.core.update(newid, {
            text,
            list: alter.list.concat(curent.list)
        }); 

        _.values(entities)
            .filter(k => k.type == 'edge' 
                && k.ref == alterid)
            .forEach(k => quark.core.update(k.id, {
                ref: newid
            }))

        quark.checkpoint()

        collectEntity(newid)
        
        quark.checkpoint()

        this.closeModal()
    }

    render(){
        var line = quark.root()
        var text = this.state.text.trim()

        
        if(text == get(line.ref).text || !text){
            var button = null;
        }else if(quark.find_name(text)){
            var alter = quark.get(quark.find_name(text))
            // console.log(quark.enlist(alter).length) // number of fields


            var button = <button className="rename" onClick={this.doMerge.bind(this)}>Rename & Merge</button>
        }else{
            var button = <button className="rename" onClick={this.doRename.bind(this)}>Rename</button>
        }

        return <Modal isOpen={true} onRequestClose={this.closeModal.bind(this)}>
            <input 
                ref="namefield" 
                type="text" 
                defaultValue={this.state.text} 
                onChange={this.updateText.bind(this)} />
            <button className="cancel" onClick={this.closeModal.bind(this)}>Cancel</button> {button}
        </Modal>
    }
}


export default class Azimuth extends Lombax {
    constructor(props){
        super(props)
        this.state = { index: 0 }
        // this.state.index = 0
    }
    focusNext(){
        var {line, path} = this.props;
        if(line.type == 'search'){
            var nchildren = quark.get_children(this.props.line).length;
            this.setState({ index: Math.min(nchildren - 1, this.state.index + 1) })
        }else return super.focusNext();
    }
    focusPrev(){
        var {line, path} = this.props;
        if(line.type == 'search'){
            this.setState({ index: Math.max(0, this.state.index - 1) })
        }else return super.focusPrev();
    }

    handleTab(shift){
        var {line, path} = this.props;
        if(line.type == 'search'){
            this.handleEnter(false, false)
            // this.setFocus('__root__')
            this.focus()
            this.input().cm.setCursor({ch: 1e8, line: 1e8})
            globalUpdate()    
        }
    }
    handleEnter(shift, focus_child = true){
        var {line, path} = this.props;
        if(line.type == 'search'){
            var result = quark.get_children(line)[this.state.index];
            if(result.type == 'lazy'){
                quark.set_text(undefined, line, tok(fid(result.name)))
                quark.checkpoint()
                var root = quark.root();
                this.input().updateText(quark.get_text(root))
            }else if(result.type == 'graphview'){
                quark.set_text(undefined, line, '')
                // quark.checkpoint()
                var root = quark.root();
                this.input().updateText('')
                global.graphView = true;
                globalUpdate()
            }else if(result.type == 'scratchpad'){
                this.makeScratchpad()    
                
                return
            }else if(result.ref){
                quark.set_text(undefined, line, result.ref)
                quark.checkpoint()
                var root = quark.root();

                this.input().updateText(quark.get_text(root))
            }else{
                var root = quark.new_scratchpad()
            }
            if(focus_child){
                var children = quark.get_children(root);
                if(children.length == 0){
                    this.setFocus(quark.create_child(root))
                    quark.checkpoint()
                }else{
                    if(children.length > 6){
                        this.setFocus(children[0].id)
                    }else{
                        this.setFocus(children[children.length - 1].id)
                    }
                }    
            }
            
            globalUpdate()

        }else return super.handleEnter(shift);
    }
    onChange(text){
        super.onChange(text)
        if(this.state.index) 
            this.setState({ index: 0 });
    }
    selectIndex(index){
        this.setState({ index: index });
    }
    clickIndex(index){
        this.setState({ index: index });
        this.handleEnter(false)
        globalUpdate()
    }
    clickPrefix(){
        quark.set_text(undefined, quark.root(), '')
        quark.checkpoint()
        globalUpdate()
        this.focus()
    }
    clickRename(){
        global.$$root$$.is_renaming = true
        globalUpdate()
    }
    render_node(){
        var {line, path} = this.props;
        var popover = null;
        if(line.show_popover){
            popover = <div className="popover bottom">
                <div className="arrow"></div>
                <div>
                    <a onClick={this.clickRename.bind(this)}>Rename Entity</a>
                </div>
            </div>    
        }
        var modal = null;
        if(line.is_renaming){
            modal = <EntityRenameDialog />
        }

        return <div>
            <div className="azimuth-prefix" onClick={this.clickPrefix.bind(this)}>
                <span className={"glyphicon glyphicon-search"} />
            </div>
            {super.render_node()}
            {popover}
            {modal}
        </div>
    }
    render_children(children){
        var {line, path} = this.props;
        var {index} = this.state;


        if(line.type == 'search'){
            // return "the meaning of life is whaaat"
            var query = line.text;

            return children.map((k, i) => {
                return <div 
                    onClick={e => this.clickIndex(i)}
                    onMouseEnter={e => this.selectIndex(i)}
                    className={classNames({ 
                        result: true, 
                        selected: i == index,
                        // fresh: k.type == 'fresh',
                        // action: k.type == 'action'
                    })}
                    key={i}>
                    {k.icon ? <span className={"glyphicon glyphicon-" + k.icon} /> : null}
                    <span className="prefix">
                        <Emboldinator 
                            str={k.prefix||''} 
                            query={query.trim()} />
                    </span>
                    <span className="suffix">
                        <Emboldinator 
                            str={k.suffix||''} 
                            query={query.trim()} />
                    </span>
                </div>
            })
        }else return super.render_children(children);
    }

}


// WEBPACK FOOTER //
// ./src/react/Azimuth.jsx